import { render, staticRenderFns } from "./selfMenu.vue?vue&type=template&id=52d47780&scoped=true"
import script from "./selfMenu.vue?vue&type=script&lang=js"
export * from "./selfMenu.vue?vue&type=script&lang=js"
import style0 from "./selfMenu.vue?vue&type=style&index=0&id=52d47780&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d47780",
  null
  
)

export default component.exports